export const LOGIN = 'LOGIN'

export const LOGOUT = 'LOGOUT'



// WEBPACK FOOTER //
// ./src/store/userConstant.js